export default {
    _prefix: "AlertMessageStatus",
    labels: {
        evaluationAssistanceFailed: "Evaluation Assistance was unable to run.",
        aiScoringProcessingFailure:
            "Genesys AI failed to process this evaluation.",
        aiScoringQuotaReached:
            "AI Scoring limit for daily evaluations for this agent has been reached. Genesys AI could not process this evaluation.",
        aiScoringDuplicateFormSameAgent:
            "This evaluation is a duplicate of an existing evaluation associated with this interaction. Genesys AI did not process this evaluation.",
        aiScoringUnauthorizedFailure:
            "AI license for your organization was not found. Genesys AI could not process this evaluation.",
        aiScoringDuplicateAutomatedFormWithCopiedScore:
            "This evaluation is a duplicate. Answers have been copied from the original evaluation of this interaction.",
        insufficientPermissions: {
            topicView:
                "You do not have the necessary permissions to view information related to Topics. Contact an administrator to update your permissions settings.",
            transcriptView:
                "You do not have the necessary permissions to view information related to the transcript. Contact an administrator to update your permissions settings.",
            topicAndTranscriptView:
                "You do not have the necessary permissions to view information related to Topics or the transcript. Contact an administrator to update your permissions settings.",
        },
    },
};
